import { InformationEquipmentListCard } from 'app/components/equipment';
import { formatInvitationToEquipmentListGrantedAccessI18nKey } from 'app/components/equipment/invitations/utils';
import { PendingIcon } from 'app/components/icons';
import moment from 'moment';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Invitation } from 'services/api/invitations/types';

interface Props {
  className?: string;
  invitations: Invitation[];
}

export default function UpcomingAccessEquipmentListCard({
  className,
  invitations,
}: Props) {
  const { t } = useTranslation();

  const sentInvitations = useMemo(() => {
    return [...invitations].sort((a, b) =>
      moment(b.accessDetails.invitedAt).diff(a.accessDetails.invitedAt),
    );
  }, [invitations]);

  const items = useMemo(
    () =>
      sentInvitations.map(formatInvitationToEquipmentListGrantedAccessI18nKey),
    [sentInvitations],
  );

  if (!sentInvitations.length) {
    return null;
  }

  return (
    <InformationEquipmentListCard
      icon={PendingIcon}
      title={t(
        'access_sharing.equipment_list.invitations.upcoming-access.title',
      )}
      items={items.slice(0, 2)}
      className={className}
      link={items.length > 2 ? '/access' : undefined}
    />
  );
}
